export default __webpack_public_path__ + "226fb02c51cac84605cc5f42901b0e38.png";